const LANDING_ORIGIN = 'https://oidotipi.com';
export const LEGAL_DOCUMENTS = {
    terms: {
        id: 'terms',
        publishedAt: '2026-07-11',
        path: '/terms-and-conditions',
        url: `${LANDING_ORIGIN}/terms-and-conditions`,
        title: 'Términos y Condiciones',
    },
    privacy: {
        id: 'privacy',
        publishedAt: '2026-08-14',
        path: '/privacy-policy',
        url: `${LANDING_ORIGIN}/privacy-policy`,
        title: 'Política de Privacidad',
    },
    cookies: {
        id: 'cookies',
        publishedAt: '2026-08-14',
        path: '/cookie-policy',
        url: `${LANDING_ORIGIN}/cookie-policy`,
        title: 'Política de Cookies',
    },
    dpa: {
        id: 'dpa',
        publishedAt: '2026-07-11',
        path: '/data-processing-agreement',
        url: `${LANDING_ORIGIN}/data-processing-agreement`,
        title: 'Contrato de Encargo de Tratamiento de Datos',
    },
};
//# sourceMappingURL=LegalDocuments.js.map